import {
  CircularProgress,
  createStyles,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Theme,
  Typography,
} from "@material-ui/core";
import MuiDialog from "@material-ui/core/Dialog";
import trash from "assets/icons/TrashIllustration.svg";
import { CSS_COLOR_VARS } from "constants/colors";
import useText from "constants/text";
import React from "react";
import { Button } from "ui/Button";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperWidthMd: {
      width: 740,
    },
    paperWidthLg: {
      width: 940,
      minWidth: 600,
    },
    paperWidthSm: {
      maxWidth: "80%",
    },
    dialogSpacingContent: {
      textAlign: "center",
      padding: "28px",
      fontSize: "1.2rem",
      fontWeight: "bold",
      color: "#a8a4a4",
      width: 600,
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      [theme.breakpoints.down("xs")]: { width: "330px", height: "234px" },
    },
    paperDialogRoot: {
      position: "relative",
      boxShadow: "0px 15px 20px 3px rgba(0, 0, 0, 0.1)",
    },
    dialogActions: {
      borderTop: "1px solid #d2cdcd",
    },
    dialogActionsContainer: {
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
    },
    dialogActionsRoot: {
      marginLeft: "auto",
      padding: 0,
    },
    dialogActionsConfirmClose: {
      position: "absolute",
      bottom: 0,
      justifyContent: "flex-end",
      backgroundColor: CSS_COLOR_VARS.backgroundPrimary,
      pointerEvents: "auto",
      height: "16%",
      width: "100%",
      padding: "14px 28px",
      borderRadius: "4px",
      zIndex: theme.zIndex.modal + 1,
      boxSizing: "border-box",
      textTransform: "none",
    },
    primaryAction: {
      backgroundColor: theme.palette.error.main,
      color: "#fff",
      "&:hover": {
        backgroundColor: theme.palette.error.dark,
      },
    },
    confirm: {
      background: "#ed7172",
    },
    secondary: {
      background: "red",
    },
    imag: {
      [theme.breakpoints.down("xs")]: {
        width: "260px",
        height: "174px",
      },
    },
    message: {
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
  })
);
interface DeleteDialogprops {
  title?: string;
  message: string;
  handlerConfirm: any;
  handlerCancel: any;
  open: boolean;
  onLoadingConfirm?: boolean;
  confirmTitle?: string;
  cancelTitle?: string;
}
export function DeleteDialog({
  title,
  message,
  handlerConfirm,
  handlerCancel,
  open,
  onLoadingConfirm = false,
  confirmTitle,
  cancelTitle,
}: DeleteDialogprops) {
  const { text } = useText();
  const dialogRef = React.useRef(null);
  const styles = useStyles();
  return (
    <MuiDialog
      title={title}
      open={open}
      onClose={handlerCancel}
      classes={{
        paperWidthMd: styles.paperWidthMd,
        paperWidthLg: styles.paperWidthLg,
        paperWidthSm: styles.paperWidthSm,
        paper: styles.paperDialogRoot,
      }}
    >
      <DialogTitle disableTypography>
        <Typography
          variant="h3"
          css={`
            font-weight: 500;
            color: ${CSS_COLOR_VARS.textSecondary};
          `}
        >
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent ref={dialogRef} className={styles.dialogSpacingContent}>
        <img src={trash} alt="trash" className={styles.imag} />
        <div className={styles.message}>{message}</div>
      </DialogContent>

      <DialogActions className={styles.dialogActions}>
        <Button variant="outlined" onClick={handlerCancel}>
          {cancelTitle ?? text.all.cancel}
        </Button>

        <Button
          variant="contained"
          disabled={onLoadingConfirm}
          onClick={handlerConfirm}
          className={styles.primaryAction}
          classes={{ root: styles.confirm, focusVisible: styles.secondary }}
        >
          {onLoadingConfirm ? <CircularProgress style={{ color: "white" }} /> : confirmTitle ?? text.all.confirm}
        </Button>
      </DialogActions>
    </MuiDialog>
  );
}
